import { Component, HostBinding } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { useFeatureStyles } from '@spartacus/core';
import { Observable } from 'rxjs';
import { GonvarriLoginFormComponentService } from 'src/app/core/services/gonvarri-login-form-component.service';

@Component({
    selector: 'cx-login-form',
    templateUrl: './gonvarri-login-form.component.html',
    styleUrl: './gonvarri-login-form.component.scss',
    standalone: false
})
export class GonvarriLoginFormComponent {
  constructor(protected service: GonvarriLoginFormComponentService) {
    useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
  }

  form: UntypedFormGroup = this.service.form;
  isUpdating$: Observable<boolean> = this.service.isUpdating$;

  @HostBinding('class.user-form') style = true;

  onSubmit(): void {
    this.service.login();
  }
}
